import { render, staticRenderFns } from "./IndexHeader.vue?vue&type=template&id=e8450c32&scoped=true&"
import script from "./IndexHeader.vue?vue&type=script&lang=js&"
export * from "./IndexHeader.vue?vue&type=script&lang=js&"
import style0 from "./IndexHeader.vue?vue&type=style&index=0&id=e8450c32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8450c32",
  null
  
)

export default component.exports